import React from 'react';
import {NavLink} from 'react-router-dom';
import { deleteCookie } from '../utils/Cookies';

const Sidebar = ({toggleOpen=false,onClick,history,location}) => {
    const isFarmer = location.pathname.toLocaleLowerCase().indexOf("farmer")>-1
    return(
        <div id="sidebar-nav" className={`sidebar ${toggleOpen?"open":"closed"}`}>
            <div className="sidebar-scroll">
                <nav>
                    <ul className="nav">
                        <li><NavLink onClick={()=>onClick()} to="/" exact activeClassName="active"><i className="lnr lnr-user"></i>
                            <span>Home</span></NavLink>
                        </li>
                        <li>
                            <a href="#subPages2" data-toggle="collapse" className={`${isFarmer?"active":"collapse"}`}><i
                                className="lnr lnr-users"></i> <span>Farmers</span> <i
                                className="icon-submenu lnr lnr-chevron-left"></i></a>
                            <div id="subPages2" className={`collapse ${isFarmer?"in":""}`}>
                                <ul className="nav">
                                    <li><NavLink  onClick={()=>onClick()} to="/farmers" activeClassName="active">My Farmers</NavLink></li>
                                    <li><NavLink  onClick={()=>onClick()} to="/allfarmers" activeClassName="active">All Farmers</NavLink></li>
                                </ul>
                            </div>
                        </li>

                        <li><NavLink  onClick={()=>onClick()} to="/voucher" activeClassName="active" className=""><i
                            className="lnr lnr-book"></i> <span>Vouchers</span></NavLink>
                        </li>

                        <li><NavLink  onClick={()=>onClick()} to="/billing" activeClassName="active" className=""><i
                            className="lnr lnr-file-empty"></i> <span>Billing</span></NavLink>
                        </li>
                        <li><NavLink to="/login" onClick={()=>{deleteCookie("accessToken")}} activeClassName="active" className=""><i
                            className="lnr lnr-exit"></i> <span>Logout</span></NavLink></li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar.js